import { jsxs as t, jsx as r } from "react/jsx-runtime";
import e from "./alert-summary.module.less.js";
const n = ({ heading: s, messages: a, className: l, type: m = "error" }) => /* @__PURE__ */ t("div", { className: [e.wrapper, l, e[m]].join(" "), children: [
  s && /* @__PURE__ */ r("p", { className: [e.heading, "body-base bold"].join(" "), children: s }),
  /* @__PURE__ */ r("ul", { className: e.list, children: a.map((o, i) => /* @__PURE__ */ r("li", { className: "body-base mb-0 ", children: o.text }, i)) })
] });
export {
  n as AlertSummary,
  n as default
};
